module.exports = __webpack_public_path__ + "svgs/no-search-counpongoods.99e2f183.svg";